export default from './profile-page';



// WEBPACK FOOTER //
// ./app/containers/profile-page/index.js